export default function getRandomString(len: number): string {
	const bytes = new Uint32Array(len);
	window.crypto.getRandomValues(bytes);
	return Array.from(
		bytes,
		(dec) => dec.toString(16),
	).join('');
}
